module.exports.JOIN_ORGANIZATION_VALIDATION_URL = '/signup_validation';
module.exports.UPDATE_EMAIL_URL = '/update_email';
module.exports.SHOW_LOGIN_KEY = 'show_login';
